import './contentPage.scss';
import React from 'react';
import Seo from '@src/components/Seo';
import { EmbeddableContent } from '@src/templates/EmbeddableContent';
import { graphql } from 'gatsby';

export const ContentPage = ({ location, pageContext, data }) => {
	const vehicleTypes = data.pimcore.getVehicleTypeListing.edges.map(edge => edge.node);
	return (
		<>
			<EmbeddableContent pageContext={pageContext} location={location} vehicleTypes={vehicleTypes} />
		</>
	);
};

// GraphQL Query
export const Query = graphql`
	query VehicleTypeQueryOtherCars($lang: String) {
		pimcore {
			getVehicleTypeListing(defaultLanguage: $lang) {
				edges {
					node {
						id
						Model
						Brand
						NoOfSeats
						AddtionalInformation
						Size
						Towbar
						Specifications
						Description
						VehicleType
						RidecellID
						RatePerHour
						RatePerKilometer
						RatePerHourBusiness
						RatePerKilometerBusiness
						FlexPrice
						FlexPriceBusiness
						FlexPriceExtraText
						Images {
							image {
								filename
								fullpath(thumbnail: "car_list")
								srcset(thumbnail: "car_list") {
									descriptor
									url
									resolutions {
										url
										resolution
									}
								}
							}
						}

						BrickImages: Images {
							image {
								filename
								fullpath(thumbnail: "car_brick")
								srcset(thumbnail: "car_brick") {
									descriptor
									url
									resolutions {
										url
										resolution
									}
								}
							}
						}
						MainImage {
							filename
							fullpath(thumbnail: "car_large")
							srcset(thumbnail: "car_large") {
								descriptor
								url
								resolutions {
									url
									resolution
								}
							}
						}
						ModalDocumentLink {
							path
						}
						Tier {
							... on Pimcore_fieldcollection_PriceTier {
								memberShipLevelActive
								membershipLevelName
								membershipButton {
									path
									text
								}
								numberOfUsers
								monthlyFee
								costPerHour
								costPerHourDiscount
								costPerDay
								costPerDayDiscount
								costPerWeekend
								costPerWeekendDiscount
								costPerWeek
								costPerWeekDiscount
								costPerMonth
								costPerMonthDiscount
								costPerKm
								costPerKmDiscount
								adminPortal
								advancedReport
								card
								community
								costCenters
								customOnboarding
								customPlaces
								environmentalReport
								extra1
								extra2
								extra3
								extra4
								extra5
								invoice
								journal
								logo
								premiumSupport
							}
						}
						B2BTier {
							... on Pimcore_fieldcollection_PriceTierBusiness {
								memberShipLevelActive
								membershipLevelName
								membershipButton {
									path
									text
								}
								numberOfUsers
								monthlyFee
								costPerHour
								costPerHourDiscount
								costPerDay
								costPerDayDiscount
								costPerWeekend
								costPerWeekendDiscount
								costPerWeek
								costPerWeekDiscount
								costPerMonth
								costPerMonthDiscount
								costPerKm
								costPerKmDiscount
								adminPortal
								advancedReport
								card
								community
								costCenters
								customOnboarding
								customPlaces
								environmentalReport
								extra1
								extra2
								extra3
								extra4
								extra5
								invoice
								journal
								logo
								premiumSupport
							}
						}
						Disclaimer
						B2BDisclaimer
					}
				}
			}
		}
	}
`;
export const Head = ({ location, pageContext }) => <Seo pageContextData={pageContext} location={location} />;

export default ContentPage;
